<script setup lang="ts">

import FormLabel from "./FormLabel.vue";
import {CssClasses} from "../../types/ui";
import {computed} from "vue";

const props = withDefaults(defineProps<{
	label: string;
	cssClass?: CssClasses;
	containerCssClass?: CssClasses;
	isRequired?: boolean;
	forId?: string;
	layout?: 'vertical' | 'horizontal';
	labelSize?: number;
}>(), {
	labelSize: 2,
	layout: 'horizontal',
	isRequired: false,
});

const isHorizontal = computed(() => props.layout === 'horizontal');
const labelCssClass = computed<CssClasses>(() => [
	isHorizontal.value ? `col-sm-${props.labelSize} col-form-label` : 'form-label',
	props.cssClass,
]);

</script>

<template>
	<div :class="[isHorizontal ? 'row mb-3' : 'mb-3', props.containerCssClass]">
		<FormLabel :label="props.label" :css-class="labelCssClass" :is-required="props.isRequired"
		           :for-id="props.forId"/>
		<div v-if="isHorizontal" :class="`col-sm-${12 - props.labelSize}`">
			<slot></slot>
		</div>
		<slot v-else></slot>
	</div>
</template>

<style scoped>

</style>